import { TextareaHTMLAttributes, forwardRef } from "react";

interface ITextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  errorMessage?: string;
}

// correct way to forward textarea's ref
const Textarea = forwardRef<HTMLTextAreaElement, ITextareaProps>(
  ({ errorMessage, className = "", ...restOfProps }, ref) => (
    <div className={`YasuLibTextarea flex flex-col ${className}`}>
      <textarea
        className="border-none text-base rounded-2xl sm:text-xl p-5 resize-none font-figtree"
        ref={ref}
        {...restOfProps}
      />
      <span className="TextareaErrorMessage text-red-600 max-sm:text-xs text-sm py-1 pl-3 h-7">{errorMessage}</span>
    </div>
  ),
);

export default Textarea;
